import React from 'react';
import { BaseMenu } from './BaseMenu';
import { BaseActionsMenuButton } from './BaseActionsMenuButton';
import {
  BaseActionsMenuProps as ActionMenuProps,
  Action as ActionType,
} from '../../constants';

export type Action = ActionType;

type BaseActionMenuProps = ActionMenuProps & {
  parentComponentType?: 'toolbar' | 'tableAction';
  preventClickEventPropagation?: boolean;
};

export const BaseActionsMenu: React.FC<BaseActionMenuProps> = ({
  actions,
  parentComponentType = 'tableAction',
  onActionButtonAnchorElSet,
  preventClickEventPropagation = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (menuOptions: ActionMenuProps) => {
    const anchorElValue =
      (menuOptions?.menuProps?.anchorEl as HTMLElement) || null;

    setAnchorEl(anchorElValue);

    if (onActionButtonAnchorElSet) {
      onActionButtonAnchorElSet(anchorElValue);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!actions.length) {
    return <div />;
  }

  return (
    <div>
      <BaseActionsMenuButton
        parentComponentType={parentComponentType}
        onActionMenuClick={handleClick}
        actions={actions}
      />
      <BaseMenu
        actions={actions}
        preventClickEventPropagation={preventClickEventPropagation}
        menuProps={{
          id: 'actions-menu',
          anchorEl,
          getContentAnchorEl: null,
          keepMounted: true,
          open,
          onClose: handleClose,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        }}
      />
    </div>
  );
};
